import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function IPerfDestination() {
    return (
        <React.Fragment>
            <p>
                {' '}
                The destination, typically an SDCX server, can be configured to receive packets via iPerf to determine
                if firewall rules are correctly configured and the maximum achievable transfer speed and bandwidth.
            </p>
            <p>
                To prepare the server for the test:
                <br />
                <br />
                <ol>
                    <li>Connect to the destination server using SSH or another remote access tool.</li>
                    <br />
                    <li>
                        Download and install <a href="https://iperf.fr">iPerf</a> on the server.
                    </li>
                    <br />
                    <li>
                        Start iPerf in server mode listening on a file transfer port: <br />
                        <br />
                        <code className="language-text">iperf3 -s -p {'<port>'}</code>
                        <br />
                    </li>
                </ol>
            </p>
            <p>
                Once the server is running on port 49321 (Media Shuttle) or port 50221 (Jet), it is ready to receive
                packets from the source.
            </p>
            <h3>Command Reference</h3>
            <ul>
                <li>
                    <code className="language-text">-s</code> sets the application to run as a server that will receive
                    packets
                </li>
                <li>
                    <code className="language-text">-p {'<port>'}</code> sets the port number to listen on for packets
                </li>
            </ul>
        </React.Fragment>
    );
}

IPerfDestination.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IPerfDestination);
